import axios from 'axios'
const request = axios.create({
  timeout: 8000,
  baseURL: 'http://120.24.98.37'
})
export default request